export default __webpack_public_path__ + "static/media/icici_lombard.ad3ff4d0.svg";